define(
    'GeoLocate/Redirect',["eventManager", "geoip", "Utility/ErrorHandler"],
    function (eventManager, geoip, errorHandler) {
        "use strict";

        function Redirect(scope, countrySiteMap, languageSiteMap, browserLanguage, currentSiteCountry) {

            var redirectParamName = "geo=1",
                   defaultWebSiteLanguage = "en-US",
                   url = window.location.href;

            var redirectBrowser = function (site) {
                var queryString = window.location.search;

                if (queryString.indexOf(redirectParamName) !== -1) {
                    return false;
                }

                var redirectParam = queryString.indexOf('?') !== -1 ? "&" + redirectParamName : "?" + redirectParamName;
                var uri = location.protocol + "//" + site + queryString + redirectParam;

                window.location = uri;
                //console.log(uri);

                return false;
            };

            var redirectToLanguage = function (language) {
                var chosenLanguage = language;
                var site;

                Object.keys(languageSiteMap).map(function (key) {
                    if (chosenLanguage.startsWith(key)) {
                        site = languageSiteMap[key];
                    }
                });

                return site;
            };

            var redirectOnCountryCode = function (countryCode) {
                var site;

                Object.keys(countrySiteMap).map(function (key) {
                    if (countryCode === key) {
                        site = countrySiteMap[key];
                    }
                });

                return site;
            };

            var onSuccess = function (geoipResponse) {
                var countryCode = geoipResponse.country.iso_code ? geoipResponse.country.iso_code.toLowerCase() : "";

                if (currentSiteCountry === countryCode) {
                    eventManager.trigger("GeolocationRedirectComplete");
                    return;
                }

                var site = redirectOnCountryCode(countryCode);

                if (!site) {
                    site = redirectToLanguage(browserLanguage);
                    if (!site) {
                        site = redirectToLanguage(defaultWebSiteLanguage);
                    }
                }

                if (site) {
                    redirectBrowser(site);
                }
            };

            var onError = function (error) {
                errorHandler.logError("Geop2 call to coutry API failed with error: " + error.error);

                var site = redirectToLanguage(defaultWebSiteLanguage);

                redirectBrowser(site);
            };

            //if (url.indexOf('?' + redirectParamName + '=') === -1 && url.indexOf('&' + redirectParamName + '=') === -1) {
            //    geoip2.country(onSuccess, onError);
            //}
        }

        return function initRedirect(args) {
            return args.IsExperienceEditorEditing ? null : new Redirect(
                args.scope,
                args.CountrySiteMap,
                args.LanguageSiteMap,
                args.BrowserLanguage,
                args.CurrentSiteCountry);
        };
    });
